const palette = {
  modules: {
    sideMenu:
      'linear-gradient(173.89deg,#181e33 -41.24%,#17223c -4.03%,#152948 9.89%,#152c4d 32.98%,#152c4d 54.35%,#143055 82.94%,#13335b 100.43%,#103e70 110.12%,#0f4177 113.54%)',
    sideMenuSecondary:
      'linear-gradient(180deg,#1f2f46 -16.89%,#1b283b 25.29%,#192433 59.49%,#17212e 100%)',
    sideMenuSecondaryDesktop:
      'linear-gradient(90.15deg,rgba(113,208,244,.1) 1.31%,rgba(113,208,244,0) 104.84%)',
    divider: '#ffffff20',
    readButton: '#339ae6',
    navbar: '#182634',
    appBarItem: '#768da9',
    appBarrActive: '#ffcd43',
    appBar: '#1f2f46',
    input: '#253853',
    inputAction: '#364254',
    boxGradient: '#00264e33',
    border: '#ffffff0f',
    checked: '#0ecb81',
    pending: '#e99831',
    colorChartMarginGreen: '#5BE12C',
    colorChartMarginOrange: '#EA4228',
    colorChartMarginYellow: '#F5CD19',
    colorChartMarginRed: '#FF0000',
    headerModules: '#ffffff0a',
    backgroundIconNotification: 'rgb(255 205 67 / 1%)',
    backgroundHoverNotification:
      'linear-gradient(270.04deg,hsla(0,0%,100%,.08) -1.37%,hsla(0,0%,100%,0) 94.34%)',
    backgroundBadge: '#f50057',
    logoColor: '#fff',
    logoColor2: '#09f',
    headerShadow: 'rgba(240, 185, 11,.301961)',
    buttonColor: '#000000',
    tableHead:
      'linear-gradient(187.37deg, rgba(0, 38, 78, 0.2) -30.65%, transparent 220.7%), rgba(244, 244, 244, 0.04)',
    menuIconColor: '#ffffff',
    successModalBg: "#244d41",
    successModalBgBorder: "#5f97876e",
  },

  action: {
    disabledBackground: '',
  },

  divider: '#ffcd4324',

  primary: {
    main: '#182634',
    dark: '#3f4e63',
    light: '#253853',
    alternate: '#24354d',
  },

  secondary: {
    main: '#ffcd43',
    light: '#ffcd431a',
    primary: '#ffcd43',
    lightest: '#ffcd4340',
  },

  info: {
    main: '#364254',
    secondary: '#2f3e53',
    lightest: '#ffcd43',
    light: '#939dac',
  },

  text: {
    primary: '#ffffff',
    main: '#ffffff',
    light: '#333333',
    secondary: '#939dac',
    alternate: '#ffcd43',
  },

  background: {
    alert: '#2f3e53',
    main: '#182634',
    default: '#182634',
    paper: '#182634',
    menu: '#29384f',
    headerModal: '#29384f',
    buttonAction: '#ffcd43',
    button: '#ffcd4350',
    disabled: '#364254',
    lightest: '#939dac',
    coinSingle: '#182634',
    boxShadowConvert: '#71d0f400',
    boxShadowPrices: 'rgb(113 208 244 / 20%)',
    convertTrade:
      'linear-gradient(178.98deg,rgba(41,56,79,.3) -11.82%,rgba(21,41,70,.3) 115.41%)',
    primaryGradient:
      'linear-gradient(180deg,rgba(0,38,78,.2),transparent),hsla(0,0%,95.7%,.04)',

    errorGradient:
      'linear-gradient(180deg,rgba(0, 38, 78, 0.2) 0%,rgba(255, 53, 71, 0.1) 100%),rgba(244, 244, 244, 0.04)',

    successGradient:
      'linear-gradient(180deg, #00264e33 0%, #27a17c1a 100%),#f4f4f40a',

    greenGradient:
      'linear-gradient(90deg,rgba(113,208,244,.08) -3.8%,rgba(100,200,222,.08) 49.86%,rgba(83,189,196,.08) 65.61%,rgba(39,161,124,.08) 104.15%)',

    redGradient:
      'linear-gradient(90deg,rgba(113,208,244,.08) -3.8%,rgba(177,138,166,.08) 48.91%,rgba(205,108,132,.08) 73.34%,rgba(255,53,71,.08) 104.15%)',

    blueReverseGradient:
      'linear-gradient(266.48deg,rgba(26,78,129,.42) -10.27%,rgba(54,110,155,.63) 5.39%,rgba(107,171,205,.22) 40.45%,rgba(119,184,216,.13) 60.09%,rgba(133,200,229,.06) 83.64%,rgba(147,216,242,0) 110.01%)',

    blueBottomToTopGradient:
      'linear-gradient(0deg,rgba(147,216,242,.101961) -7.62%,rgba(147,216,242,0))',
    activeCart:
      'linear-gradient(180deg, rgba(0, 38, 78, 0.2) 0%, rgba(0, 0, 0, 0) 100%), rgba(113, 208, 244, 0.25)',
    blue: 'linear-gradient(177.23deg,#242993 -13.49%,#0fa09d 109.75%)',
    red: 'linear-gradient(177.23deg,#e31818 -13.49%,#940e14 40.43%,#6f0912 70.59%,#390310 109.75%)',
    tabButtonHover: '#edae00',
    tabButtonHoverColor: '#000000',
    tradeTypeButton: "#edae00",
    tradeTypeButtonActive: "#ffcd43",
    tradeTypeButtonColor: "#000000",
    telegramCard: "#ffffff",
    telegramCardColor: "#333333",
    telegramColor: "#2481cc",
    telegramQrCodeBorderColor: "#4e0b88"
  },

  success: {
    main: '#27a17c',
    primary: '#27a17c',
    light: '#27a17c',
    secondary: '#27a145',
  },

  error: {
    main: '#ff3547',
  },

  warning: {
    main: '#ff9d00',
    secondary: '#ff9d00',
  },

  common: {
    white: '#ffffff',
    black: '#000000',
  },

  grey: {
    30: '#ddd',
    50: '#939dac',
    100: '#717781',
  },
};

export default palette;
